<template>
  <b-overlay :show="loading">
    <AuctionsFilters
      :value="filters"
      :onChange="onChangeFilters"
      :clear="clearFilters"
    />
    <div class="text-left mb-2 d-flex justify-content-start align-items-center">
      <div
        class="my-2 text-primary"
        v-if="filteredAuctions.length"
      >
        <b-form-checkbox
          class="d-inline-block"
          v-model="selectAll"
          @change="selectAllAuctions"
        >
        </b-form-checkbox>
        Seleccionar todos
      </div>
      <AuctionsOptionsMasive :selected-auctions="selectedAuctions" />
      <b-button
        class="badge-glow mb-2 ml-3"
        variant="warning"
        size="sm"
        data-cy="download"
        v-on:click="onDownloadAuctions"
      >
        <feather-icon
          icon="DownloadIcon"
          class="mr-50"
        />
        <span class="align-middle">Descargar</span>
      </b-button>
      <b-button
        data-cy="auction-register"
        class="badge-glow ml-3 mb-2"
        variant="primary"
        size="sm"
        v-has-permission="'ED200'"
        @click="openModalAuction"
      >
        <feather-icon
          icon="list"
          class="mr-50"
        />
        <span class="align-middle">Registrar subasta</span>
      </b-button>
    </div>
    <AuctionsHeader />
    <div class="force-render" :key="forceRender">
      <AuctionRow
        :is-massive="isMassive"
        :selected-auctions="selectedAuctions"
        :key="auction.subastaId"
        v-for="auction in filteredAuctions"
        :auction="auction"
        @select-check-auction="selectCheckAuction"
        @unselect-check-auction="unSelectCheckAuction"
        v-on:reload-list="handleReloadList"
        :select-auction="selectAuction"
      />
    </div>
    <div class="row">
      <div class="col-3">
        <div class="mt-5">
          Mostrando
          <select v-model="rowspp" @change="fetchAuctions()">
            <option value="10" selected="selected">10</option>
            <option value="15">15</option>
            <option value="30">30</option>
            <option value="50">50</option>
          </select> registros por página.
        </div>
      </div>
      <div class="col-9">
        <AuctionsPagination
          :show="filteredAuctions.length"
          v-model="page"
        />
      </div>
    </div>
    <b-modal
      ref="new-auction"
      title="Registro de subasta"
      hide-footer
      no-close-on-backdrop
    >
      <b-overlay :show="loadingCompanies">
        <b-form data-vv-scope="auction-form">
          <b-form-group
            label="Fecha subasta"
            class="mb-3"
          >
            <date-picker
              name="date"
              v-model="auction.date"
              class="w-100"
              format="DD MMM YYYY"
              value-type="YYYY-MM-DD"
              type="date"
              data-vv-as="fecha de subasta"
              placeholder="Fecha de subasta"
              v-validate="'required'"
              :disabled-date="disabledMinDate"
              data-cy="auction-date"
            />
            <div v-if="errors.has('auction-form.date')">
              <small class="text-danger">
                {{ errors.first('auction-form.date') }}
              </small>
            </div>
          </b-form-group>
          <b-form-group
            label="Aduana coordinadora"
            class="mb-3"
          >
            <v-select
              v-model="auction.managingCustoms"
              :options="customsCompanies"
              name="managingCustoms"
              :state="errors.has('auction-form.managingCustoms') ? false : null"
              v-validate="'required'"
              data-vv-as="aduana coordinadora"
              :danger="errors.has('auction-form.managingCustoms')"
              :danger-text="errors.first('auction-form.managingCustoms')"
            >
              <span slot="no-options">
                No hay coincidencias
              </span>
            </v-select>
            <div
              v-if="errors.first('auction-form.managingCustoms')"
              class="con-text-validation span-text-validation-danger
                 vs-input--text-validation-span v-enter-to"
              style="height: 32px;"
            >
              <span class="span-text-validation">
                El campo aduana coordinadora es obligatorio
              </span>
            </div>
          </b-form-group>
        </b-form>
      </b-overlay>
      <div class="text-right">
        <b-button
          data-cy="save"
          class="badge-glow ml-3 mb-5"
          variant="primary"
          size="sm"
          :disabled="disableAddAuctionButton"
          @click="attemptAddAuction()"
        >
          Registrar
        </b-button>
      </div>
    </b-modal>
  </b-overlay>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/es';

import AuctionsFilters from '@/febos/aduanas/auctions/views/components/AuctionsFilters';
import AuctionsHeader from '@/febos/aduanas/auctions/views/components/AuctionsHeader';
import AuctionsPagination from '@/febos/aduanas/auctions/views/components/AuctionsPagination';
import AuctionRow from '@/febos/aduanas/auctions/views/components/AuctionRow';
import { removeSearchParams, updateSearchParams } from '@/febos/global/utils/router';
import { mergeFilters } from '@/febos/chile/dnt/utils/fitlers';
import { fetchAuctionsList, selectAllElements, selectAuctionState } from '@/febos/aduanas/auctions/store/actions';
import { auctions, loading } from '@/febos/aduanas/auctions/store/getters';
import { auctionsListSearch, createAuction } from '@/febos/servicios/api/aduanas/auctions.api';
import AuctionsOptionsMasive from '@/febos/aduanas/auctions/views/components/AuctionsOptionsMasive';
import { ioGetHoldingCompanies } from '@/febos/servicios/api/v2.companies.api';
import { ALERT_POSITION } from '@/febos/global/utils/configurations';

export default {
  components: {
    AuctionRow,
    AuctionsPagination,
    AuctionsFilters,
    AuctionsHeader,
    AuctionsOptionsMasive,
    DatePicker
  },
  data() {
    return {
      minDate: this.$moment().format('YYYY-MM-DD'),
      auction: {},
      isMassive: false,
      selectAll: false,
      selectedAuctions: [],
      loadingCompanies: false,
      customsCompanies: [],
      filters: '',
      rowspp: Number.parseInt(this.$route.query.paginate || 10, 10),
      page: Number.parseInt(this.$route.query.page || 1, 10),
      selectedAuction: {},
      searchParam: false,
      textSearch: '',
      disableAddAuctionButton: false,
      forceRender: Date.now() // TODO: the files watch is triggered but the component not re-render.
    };
  },
  watch: {
    async page(page) {
      updateSearchParams({ page });
      await this.fetchAuctions();
    }
  },
  computed: {
    filteredAuctions() {
      return this.auctions;
    },
    ...mapGetters('auctions', {
      auctions: auctions.name,
      loading: loading.name
    }),
    ...mapGetters('Empresas', [
      'company'
    ])
  },
  methods: {
    ...mapActions('auctions', {
      fetchAuctionsList: fetchAuctionsList.name,
      selectAuctionState: selectAuctionState.name,
      selectAllElements: selectAllElements.name
    }),
    ...mapActions('Modals', [
      'closeModal'
    ]),
    disabledMinDate(date) {
      const today = this.$moment().format('YYYY-MM-DD');
      return this.$moment(date).format('YYYY-MM-DD') < today;
    },
    selectAllAuctions() {
      this.selectAllElements(this.selectAll);
      if (this.selectAll) {
        this.isMassive = true;
        this.filteredAuctions.forEach((auction) => {
          this.selectedAuctions.push(auction);
        });
      } else {
        this.isMassive = false;
        this.selectedAuctions = [];
      }
    },
    selectCheckAuction(auction) {
      this.selectedAuctions.push(auction);
    },
    unSelectCheckAuction(auction) {
      this.selectedAuctions = this.selectedAuctions
        .filter((elm) => (elm.subastaId !== auction.subastaId));
    },
    selectAuction(auction) {
      this.selectedAuction = auction;
      this.selectAuctionState(auction.subastaId);
    },
    clearFilters() {
      removeSearchParams(['filters']);
      // TODO: try to change to default filter state for current view.
      updateSearchParams({ page: 1 });
      this.$router.go();
    },
    async onChangeFilters(filters, onMounted) {
      this.filters = filters;
      if (!onMounted) {
        if (this.page !== 1) {
          this.page = 1;
          // using else because this method has two responsibilities
        } else {
          // force fetch (if we change the page from 1 to 1 the watcher not run)
          await this.fetchAuctions();
        }
      }
    },
    fetchAuctions() {
      this.fetchAuctionsList({
        params: {
          filtros: this.getFilters(),
          orden: '-folio',
          paginaActual: this.page,
          elementosPorPagina: this.rowspp
        }
      });
    },
    getFilters() {
      if (this.$route.query?.filters) {
        if (this.$route.query.filters.includes('subastaId')) { return this.$route.query.filters; }
      }
      return mergeFilters(this.filters, this.$route.query.filters);
    },
    async onDownloadAuctions() {
      this.$vs.notify({
        title: 'Solicitando',
        text: 'Descargando archivos',
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'primary',
        position: ALERT_POSITION
      });
      try {
        const { data } = await auctionsListSearch({
          filters: this.getFilters(),
          order: '-folio',
          format: 'csv'
        });
        window.open(data.url, '_blank');
      } catch (error) {
        this.$vs.notify({
          title: 'Error',
          text: 'Ocurrió un error al descargar los registros',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success',
          position: ALERT_POSITION
        });
      }
    },
    async openModalAuction() {
      this.auction = {};
      this.disableAddAuctionButton = false;
      this.loadingCompanies = true;
      this.$refs['new-auction'].show();
      this.customsCompanies = [];
      const response = await ioGetHoldingCompanies(
        {
          empresaId: this.company.id,
          params: {
            filtros: 'esGestoria:Y'
          }
        }
      );
      this.customsCompanies = response.data.empresas
        .map((company) => ({ id: company.empresaId, label: company.razonSocial }));
      this.loadingCompanies = false;
    },
    async attemptAddAuction() {
      const result = await this.$validator.validateAll('auction-form');
      if (!result) {
        return;
      }
      this.disableAddAuctionButton = true;
      this.loadingCompanies = true;
      await createAuction({
        gestoraId: this.auction.managingCustoms.id,
        fechaSubasta: this.auction.date
      });
      this.loadingCompanies = false;
      this.$vs.notify({
        title: 'Genial!',
        text: 'Se ha registrado correctamente la subasta',
        color: 'success',
        time: 5000,
        position: 'top-center'
      });
      this.auction = {};
      this.$refs['new-auction'].hide();
      this.fetchAuctions();
    },
    handleReloadList() {
      this.fetchAuctions();
    }
  },
  created() {
    this.closeModal();
    this.selectAuctionState('');
    this.selectedAuctions = [];
  },
  mounted() {
    this.selectedAuctions = [];
    this.fetchAuctions();
  }
};
</script>

<style>
.mx-input {
  padding: 20px 10px 20px 35px;
  color: #6e6b7b;
}
.mx-icon-calendar {
  left: 10px
}
</style>
